import {
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Box,
  Link,
  Text,
} from "@chakra-ui/react";
import AuthBox from "components/elements/AuthBox";
import PasswordInput from "components/elements/PasswordInput";
import { AuthHeading } from "components/layout/AuthLayout";

import { supabase } from "index";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";
import { useState } from "react";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";

const SetPassword = () => {
  const toast = useToast();
  const { user } = useTenant();
  const { refetch } = useCurrentUserQuery();
  const [password, setPassword] = useState("");
  const [confirmP, setConfirmP] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function updatePassword(ev: React.FormEvent<HTMLFormElement>) {
    ev.preventDefault();
    try {
      setSubmitting(true);
      if (password !== confirmP) {
        throw new Error("Your passwords do not match!");
      }

      const { error: updateError } = await supabase.auth.updateUser({
        password,
        data: { password_set: true },
      });

      if (updateError) {
        throw updateError;
      }

      await apiRequest("/supabase/events/insert", {
        name: "set_password",
      });
      await refetch();
    } catch (err) {
      toast({
        title: "Update Failed",
        description: getErrorMessage(err),
        status: "error",
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthBox>
      <AuthHeading title="Set Your Password" />
      <Box w="370px">
        <form onSubmit={updatePassword}>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Email Address</FormLabel>
            <Input
              type="email"
              placeholder="john@company.com"
              value={user.email}
              disabled
              variant="primary"
            />
          </FormControl>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">New Password</FormLabel>
            <PasswordInput value={password} onChange={setPassword} />
          </FormControl>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Confirm Password</FormLabel>
            <PasswordInput
              value={confirmP}
              onChange={setConfirmP}
              placeholder="Confirm Password"
              dataCy="confirm-password"
            />
          </FormControl>
          <VStack>
            <Button
              colorScheme="blue"
              type="submit"
              mt="40px"
              mb="24px"
              px="36px"
              data-cy="create-account"
              isLoading={submitting}
            >
              Reset Password
            </Button>
            <Text fontSize="16px">
              Already a member?{" "}
              <Link href="/login" color="primary">
                Log in here
              </Link>
            </Text>
          </VStack>
        </form>
      </Box>
    </AuthBox>
  );
};

export default SetPassword;
